// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"167":"752a5640","381":"d29eaf6a"}[chunkId] + ".js";
};